import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/translation.json";
import es from "./locales/es/translation.json";
import fr from "./locales/fr/translation.json";
import pt from "./locales/pt/translation.json";

// Language is resolved through the same precedence chain as colors/logo
// (theme override -> org default -> "en") and applied via i18n.changeLanguage
// in ThemeProvider — see theme/ThemeProvider.jsx. No browser-based language
// detection: this app is embedded per-customer, not a general-audience site.
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    fr: { translation: fr },
    pt: { translation: pt },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // React already escapes values
  },
});

export default i18n;
